var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentMethodCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0156 6.75H5.125C4.77969 6.75 4.5 6.47031 4.5 6.125C4.5 5.77969 4.77969 5.5 5.125 5.5H20.125C20.4703 5.5 20.75 5.22031 20.75 4.875C20.75 3.83945 19.9105 3 18.875 3H4.5C3.11914 3 2 4.11914 2 5.5V18C2 19.3809 3.11914 20.5 4.5 20.5H20.0156C21.1102 20.5 22 19.659 22 18.625V8.625C22 7.59102 21.1102 6.75 20.0156 6.75ZM18.25 14.875C17.5598 14.875 17 14.3152 17 13.625C17 12.9348 17.5598 12.375 18.25 12.375C18.9402 12.375 19.5 12.9348 19.5 13.625C19.5 14.3152 18.9402 14.875 18.25 14.875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMethodCash);
export default __webpack_public_path__ + "static/media/payment-method-cash.906f47097336a7d572a7fc61c392e6c7.svg";
export { ForwardRef as ReactComponent };